import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'underscore';
import storage from "../core/utils/storage";


Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        token: '',
        menu: [],
        fixTag: [],
        tag: [{
            icon: "el-icon-s-home",
            path: "/main/home",
            title: "首页",
        }],
        tagActiveIndex: -1,
        userDetail: [],
        applyFriendNumber: 0,
        contact: [],
        allGroups: [],
        lang: '',
        matchFailed: 0,
        theme: () => storage.get('theme') || 'light',
    },
    getters: {
        getLang(state) {
            return state;
        },
        getMenu(state) {
            return state.menu;
        },
        getDot(state) {
            return state.menu;
        },
        getToken(state) {
            return state.token;
        },
        getTag(state) {
            return state.tag;

        },
        getUserDetail: (state) => (userId) => {
            return new Promise((resolve, reject) => {
                let detail = _.find(state.userDetail, item => item.userId === userId);
                if (detail) {
                    resolve(detail);
                } else {
                    Vue.prototype.$ChatApi.getUserDetail(userId).then(res => {
                        if (res.code === 'success') {
                            let userDetail = res.data;
                            if (userDetail) {
                                state.userDetail.push(userDetail);
                                resolve(userDetail)
                            }
                            reject();
                        } else {
                            reject();
                        }
                    }).catch(err => {
                        reject();
                    });
                }
            });
        },
        getMatchFailed(state) {
            return state.matchFailed;
        },
        getTheme(state) {
            return state.theme();
        },
    },
    mutations: {
        setDot(state, type) {
            let menus = state.menu;
            _.each(menus, (menu => {
                if (menu.children.length > 0) {
                    let children = menu.children;
                    _.each(children, (child => {
                        if (child.messageType == type.type && child.children.length == 0) {
                            if (menu.dot > 1) {
                                let tempDot = menu.dot;
                                child.dot = type.num;
                                tempDot += child.dot;
                                menu.dot = tempDot; //- menu.dot;之前是减
                            } else {

                                child.dot = type.num;
                                menu.dot += child.dot;
                                // console.log("3245235==============");
                                //  console.log(child);
                                //   console.log(menu);
                            }
                        } else if (child.children.length > 0) {
                            _.each(child.children, (son => {
                                if (son.messageType == type.type && son.children.length == 0) {
                                    var diff = type.num - son.dot;
                                    son.dot = type.num;
                                    child.dot += diff;
                                    if (menu.path == '/main/withdrawManage') {
                                        menu.dot = 0;
                                        let child = menu.children;
                                        for (let i = 0; i < child.length; i++) {
                                            menu.dot += child[i].dot
                                        }
                                    } else if (menu.path == '/main/deposit' || menu.path == '/main/anchor') {
                                        menu.dot = 0;
                                        let child2 = menu.children;
                                        for (let i = 0; i < child2.length; i++) {
                                            menu.dot += child2[i].dot
                                        }
                                    }


                                    // if (child.children >1){
                                    //     let tempChild = child.dot;
                                    //     son.dot = type.num;
                                    //     tempChild += son.dot;
                                    //     child.dot = tempChild - child.dot;
                                    //     let tempMenu = menu.dot;
                                    //     tempMenu += child.dot;
                                    //     menu.dot = tempMenu - menu.dot;
                                    // }
                                    // else{
                                    //     son.dot = type.num;
                                    //     child.dot += son.dot;
                                    //     if (menu.path=='/main/withdrawManage'){
                                    //         menu.dot =0;
                                    //         let child = menu.children;
                                    //         for(let i=0;i<child.length;i++){
                                    //             menu.dot +=child[i].dot
                                    //         }
                                    //     }else if(menu.path=='/main/deposit'){
                                    //         menu.dot =0;
                                    //         let child2 = menu.children;
                                    //         for(let i=0;i<child2.length;i++){
                                    //             menu.dot +=child2[i].dot
                                    //         }
                                    //     }
                                    // }
                                }
                            }));
                        }
                    }))
                } else {
                    if (type.type == 'chat') {
                        _.each(menus, (child => {
                            if (child.path == '/main/talk') {
                                child.dot = type.num;
                                if (child.dot && child.dot <= 0) {
                                    child.dot = 0
                                }
                                storage.set('chatDot', child.dot);
                            }
                        }))
                    }
                }
            }));
            state.menu = menus;
        },
        setLang(state, lang) {
            state.lang = lang;
            Vue._i18n.locale = lang;
            storage.set('lang', lang);
        },
        setContact(state, contact) {
            state.contact = contact;
        },
        setAllGroups(state, allGroups) {
            state.allGroups = allGroups;
        },
        setToken(state, token) {
            state.token = token;
        },
        setMenu(state, menu) {
            //console.log("设置menu");
            //console.log(menu);
            state.menu = menu;
        },
        addFixTag(state, tag) {
            state.fixTag.push(tag);
        },
        addTag(state, tag) {
            let index = _.findIndex(state.tag, item => {
                return item.path === tag.path;
            });

            if (index < 0) {
                state.tag.push(tag);
                state.tagActiveIndex = state.tag.length - 1;
            } else {
                state.tag[index] = tag;
                state.tagActiveIndex = index;
            }
        },
        deleteTag(state, tag) {
            let index = _.findIndex(state.tag, item => {
                return item.path === tag.path;
            });

            if (index >= 0) {
                state.tag.splice(index, 1);
                if (state.tagActiveIndex > index) {
                    state.tagActiveIndex = state.tagActiveIndex - 1;
                }
            }
        },
        clearTag(state) {
            state.tag = [];
        },
        setMatchFailed(state, matchFailed) {
            state.matchFailed = matchFailed;
        },
        setTheme(state, theme) {
            state.theme = () => theme;
        }
    },
    actions: {
        setDotActive(context, obj) {
            context.commit('setDot', obj)
        },
        setMatchFailed(context, num) {
            context.commit('setMatchFailed', num);
        },
        setTheme(context, theme) {
            context.commit('setTheme', theme);
        }
    }
});